export const CREATE_USEROBJECT = "CREATE_USEROBJECT";
export const GET_USEROBJECT = "GET_USEROBJECT";
export const SET_USEROBJECT = "SET_USEROBJECT";
export const UPDATE_USEROBJECT = "UPDATE_USEROBJECT";
